/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Keyword,
    KeywordFromJSON,
    KeywordFromJSONTyped,
    KeywordToJSON,
} from './Keyword';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';
import {
    PostReceiveSettingsKeywordsResponseAllOf,
    PostReceiveSettingsKeywordsResponseAllOfFromJSON,
    PostReceiveSettingsKeywordsResponseAllOfFromJSONTyped,
    PostReceiveSettingsKeywordsResponseAllOfToJSON,
} from './PostReceiveSettingsKeywordsResponseAllOf';

/**
 * 
 * @export
 * @interface PostReceiveSettingsKeywordsResponse
 */
export interface PostReceiveSettingsKeywordsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PostReceiveSettingsKeywordsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PostReceiveSettingsKeywordsResponse
     */
    message: string;
    /**
     * 
     * @type {Keyword}
     * @memberof PostReceiveSettingsKeywordsResponse
     */
    data: Keyword;
}

export function PostReceiveSettingsKeywordsResponseFromJSON(json: any): PostReceiveSettingsKeywordsResponse {
    return PostReceiveSettingsKeywordsResponseFromJSONTyped(json, false);
}

export function PostReceiveSettingsKeywordsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostReceiveSettingsKeywordsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': KeywordFromJSON(json['data']),
    };
}

export function PostReceiveSettingsKeywordsResponseToJSON(value?: PostReceiveSettingsKeywordsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': KeywordToJSON(value.data),
    };
}

